import { render, staticRenderFns } from "./VoipHistory.vue?vue&type=template&id=7860f6c9&scoped=true"
import script from "./VoipHistory.vue?vue&type=script&lang=js"
export * from "./VoipHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7860f6c9",
  null
  
)

export default component.exports